import { render, staticRenderFns } from "./widget.vue?vue&type=template&id=3ca7a1e3&scoped=true&"
import script from "./widget.vue?vue&type=script&lang=js&"
export * from "./widget.vue?vue&type=script&lang=js&"
import style0 from "./widget.vue?vue&type=style&index=0&id=3ca7a1e3&scoped=true&lang=css&"
import style1 from "./widget.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca7a1e3",
  null
  
)

export default component.exports